import React from "react";
import PropTypes from "prop-types";
import {
  Container,
  Header,
  SectionTitle,
  Details,
  Row,
  ColLabel,
  ColValue,
  Divider,
  ColValueName,
} from "./styles";

function ProductHotel({ reservation }) {
  const data = reservation || {};
  console.log(data)

  const boardLabels = {
    all_inclusive: "All inclusive",
    breakfast: "Café da manhã",
    full_board: "Pensão completa",
    half_board: "Meia pensão",
    not_included: "Não incluso",
  };

  const formattedBoard = boardLabels[data.board] || "-";

  return (
    <Container role="region" aria-label="Resumo da reserva de hotel">
      <Header>
        <SectionTitle>Resumo da Reserva</SectionTitle>
      </Header>

      <Details>
        <Row>
          <ColLabel>Hóspede:</ColLabel>
          <ColValue>{data.guestName || '-'}</ColValue>
        </Row>
        <Row>
          <ColLabel>Localizador da reserva:</ColLabel>
          <ColValue>{data.locator || '-'}</ColValue>
        </Row>
        <Row>
          <ColLabel>Destino:</ColLabel>
          <ColValue>{data.destination || '-'}</ColValue>
        </Row>
        <Row>
          <ColLabel>Nome do hotel:</ColLabel>
          <ColValueName>{data.hotelName || '-'}</ColValueName>
        </Row>
        <Row>
          <ColLabel>Quarto:</ColLabel>
          <ColValueName>{data.roomName || '-'}</ColValueName>
        </Row>
        <Row>
          <ColLabel>Alimentação:</ColLabel>
          <ColValueName>{formattedBoard}</ColValueName>
        </Row>

        <Row>
          <ColLabel>Data de check-in:</ColLabel>
          <ColValue>{data.checkIn || '-'}</ColValue>
        </Row>
        <Row>
          <ColLabel>Data de check-out:</ColLabel>
          <ColValue>{data.checkOut || '-'}</ColValue>
        </Row>
        <Row>
          <ColLabel>Diárias:</ColLabel>
          <ColValue>{typeof data.nights === 'number' ? data.nights : '-'}</ColValue>
        </Row>
        <Row>
          <ColLabel>Hóspedes:</ColLabel>
          <ColValue>{typeof data.guests === 'number' ? data.guests : '-'}</ColValue>
        </Row>
      </Details>
    </Container>
  );
}

ProductHotel.propTypes = {
  reservation: PropTypes.shape({
    status: PropTypes.string,
    guestName: PropTypes.string,
    locator: PropTypes.string,
    destination: PropTypes.string,
    hotelName: PropTypes.string,
    checkIn: PropTypes.string,
    checkOut: PropTypes.string,
    nights: PropTypes.number,
    guests: PropTypes.number,
    board: PropTypes.string,
    roomName: PropTypes.string,
    payment: PropTypes.shape({
      kind: PropTypes.string,
    }),
    total: PropTypes.shape({
      text: PropTypes.string,
    }),
  }),
};

ProductHotel.defaultProps = {
  reservation: null,
};

export default ProductHotel;


